import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Col, Row, Layout, Typography, Card } from 'antd';
import { FileOutlined } from '@ant-design/icons';
import TramittaLogo from '../../../images/tramitta-logo.png';
import LegalChileLogo from '../../../images/legalchile.svg';
import NotFound from '../../../views/NotFound';
import YapoLogo from '../../../images/yapo_logo.png';
import { EXTERNAL_URL } from '../../../config/constants/urls';
import PropTypes from 'prop-types';

const { Header, Content } = Layout;
const { Title, Text } = Typography;

const WebpayFail = ({ data, persistContractId, sourceUrl }) => {

  const [validAccess, setValidAccess] = useState(false);

  useEffect(() => {
    if (data.buy_order === persistContractId) {
      sessionStorage.removeItem('contractId');
      setValidAccess(true);
    }
  }, []);

  return (
    <React.Fragment>
      {validAccess
        ? <React.Fragment id="transaction-fail">
          <Header className="header-container">
            <Row className="header-logos mb-0">
              <img src={LegalChileLogo} alt="" className="legal-logo" />
              {sourceUrl === EXTERNAL_URL.YAPO &&
                <img src={YapoLogo} alt="" className="yapo-logo" />
              }
              <img src={TramittaLogo} alt="" className="tramitta-logo" />
            </Row>
          </Header>
          <Content className="ant-layout-content-custom">
            <Row className="mb-4">
              <Col md={12} className="text-center mx-auto">
                <FileOutlined style={{ fontSize: '40px', color: '#160B9F' }} className="mb-2" />
                <Title level={1}>Compra rechazada</Title>
              </Col>
            </Row>
            <Row>
              <Col md={18} lg={12} className="mx-auto position-relative">
                <Card xs={18} md={6} className="mx-auto mb-4">
                  <div className="text-center mb-2">
                    <Text strong>Contrato de arriendo con orden de compra nro {data.buy_order} rechazada.</Text>
                  </div>
                  <Title className="text-center mb-2" level={5}>Las posibles causas de este rechazo son:</Title>
                  <ul style={{ padding: 0 }}>
                    <li className="d-flex mb-2">
                      <Text strong>Error en el ingreso de los datos de su tarjeta de crédito o débito (fecha y/o código de seguridad).</Text>
                    </li>
                    <li className="d-flex mb-2">
                      <Text strong>Su tarjeta de crédito o débito no cuenta con saldo suficiente.</Text>
                    </li>
                    <li className="d-flex mb-2">
                      <Text strong>Tarjeta aún no habilidata en el sistema financiero.</Text>
                    </li>
                  </ul>
                </Card>
              </Col>
            </Row>
          </Content>
        </React.Fragment>
        : <NotFound />
      }
    </React.Fragment>
  );
};

WebpayFail.propTypes = {
  data: PropTypes.object.isRequired,
  persistContractId: PropTypes.string.isRequired,
  sourceUrl: PropTypes.string.isRequired,
};

const data = (state) => ({
  persistContractId: state.contract.persistContractId,
  data: state.webpay.webpayData,
  sourceUrl: state.contract.sourceUrl
});

export default connect(data, null)(WebpayFail);